import { create } from "zustand";

/**
 * エラーステート
 */
interface ErrorState {
  errorMessage: string;
  showError: boolean;
  setError: (message: string) => void;
  clearError: () => void;
}

/**
 * エラーストア
 */
export const useErrorStore = create<ErrorState>((set) => ({
  errorMessage: "",
  showError: false,
  setError: (message: string) => {
    const msg = (message ?? "").toString().trim();
    if (!msg) {
      set({
        errorMessage: "サーバーがメインテナンス中です",
        showError: true,
      });
      return;
    }
    set({ errorMessage: msg, showError: true });
  },
  clearError: () => {
    set({ showError: false });
    setTimeout(() => set({ errorMessage: "" }), 300);
  },
}));
